












import { defineComponent } from "@vue/composition-api";
import { Message } from "@scrile/api-provider/dist/api/MessagesProvider";
import { isTipMessageDetails, TipMessageDetails } from "@scrile/api-provider/dist/api/TipProvider";
import BaseIcon from "@/components/BaseIcon";
import FormatMoney from "@/components/FormatMoney/FormatMoney.vue";
import MessageItemLink from "../components/MessageItemLink";
import MessageView from "../mixins/MessageView";

export default defineComponent({
  name: "SystemMessageTip",
  inheritAttrs: false,
  components: { FormatMoney, BaseIcon, MessageItemLink },
  mixins: [MessageView],
  props: {
    message: { type: Object as () => Message, required: true },
    authUserId: { type: String, required: true },
  },
  computed: {
    details(): TipMessageDetails | null {
      return isTipMessageDetails(this.message.details) ? this.message.details : null;
    },
  },
  mounted() {
    this.$emit("rendered", { el: this.$el });
  },
});
